import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingJpegToPngConfig } from '@/data/landingConfig/landingJpegToPngConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_JpegToPng } from './schemaObject';

interface Props {}
const JpegToPngConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_JpegToPng} />
			<LandingTemplate
				data={landingJpegToPngConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default JpegToPngConverter;
